import gql from "graphql-tag";

const EDIT_NAVSLOT_MUTATION = gql`  
  mutation editNav($navigationData: NavSlotInput!) {
      editNavSlot(navigationData:$navigationData){
        id
        name
        description
        slug
        menu{
          id
          name
          description
          items{
            id
            label
            uri
            description
          }
        }
      }
    }
`;

export default EDIT_NAVSLOT_MUTATION;